module.exports = __webpack_public_path__ + "static/media/stocks.67ea37fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/stocks.png
// module id = 468
// module chunks = 0